// ToDo: Move to API_CONSTANTS
export default {
  LANGUAGE: {
    CODE: 'code',
    TITLE: 'title',
    URL: 'url',
    CURRENT: 'current',
  },
  LINKS: 'navigation/icon_item',
  LINK_TILE_ITEM_TYPE: 'linktile',
  CHILDREN: 'children',
  LINK_TILE_CHILDREN: 'children_link_tiles',
  ACTIONS: {
    APP: {
      LOGOUT: 'app-logout',
      CHANGE_LANG: 'app-change-language',
      STORE_MODE_ON: 'app-store-mode-on',
      STORE_MODE_OFF: 'app-store-mode-off',
    },
    MENU: {
      ACTIVE: 'menu-button-active',
      DISABLED: 'menu-button-disabled',
      CLICKED: 'menu-button-clicked',
    },
  },
  ICONS: {
    NEWS: 'news',
  },
  USER_AGENTS: {
    MOBILE: 'show only mobile',
    DESKTOP: 'show only desktop',
    ALL: 'show on all devices',
  },
}
